import PublicLayout from "@/components/public/PublicLayout";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return toast.error("Please fill all fields");
    toast.success("Thanks! We'll get back within 1 business day.");
    setForm({ name: "", email: "", message: "" });
  };
  return (
    <PublicLayout>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-16 grid md:grid-cols-2 gap-8">
        <div>
          <h1 className="font-heading text-4xl font-bold tracking-tight">Get in touch</h1>
          <p className="text-muted-foreground mt-3">Questions? Feedback? We&apos;d love to hear from you.</p>
          <div className="mt-8 space-y-3">
            <div className="flex items-center gap-3 text-sm"><Mail size={16} className="text-primary" /> hello@thebillpro.com</div>
            <div className="flex items-center gap-3 text-sm"><Phone size={16} className="text-primary" /> +91 98765 43210</div>
            <div className="flex items-center gap-3 text-sm"><MessageCircle size={16} className="text-primary" /> WhatsApp support 9 AM–7 PM IST</div>
          </div>
        </div>
        <Card className="p-6">
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" /></div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" /></div>
            <div>
              <Label>Message</Label>
              <textarea className="w-full mt-1 rounded-lg border bg-background px-3 py-2 text-sm" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
            </div>
            <Button type="submit" className="w-full" data-testid="contact-submit">Send message</Button>
          </form>
        </Card>
      </section>
    </PublicLayout>
  );
}
